import { Dispatch, SetStateAction } from 'react';
import styled from 'styled-components';
import { format } from 'date-fns';
import { colors, spacing } from 'ui/theme';
import { CalendarNavigation } from './CalendarNavigation';
import { CalendarViewType } from 'modules/campaignsCalendar/constants';
import { FlexSpacer } from 'ui/flexSpacer';
import { SegmentedControl } from 'ui/segmentedControl/SegmentedControl';

const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: ${spacing.base};
`;

const YearTitle = styled.span`
  color: ${colors.textSecondary};
`;

const DateTitle = styled.h3`
  margin: 0;
`;

interface CalendarHeaderProps {
  currentDate: Date;
  viewType: CalendarViewType;
  setCurrentDate: Dispatch<SetStateAction<Date>>;
  setViewType: Dispatch<SetStateAction<CalendarViewType>>;
}

export const CalendarHeader = ({
  currentDate,
  viewType,
  setCurrentDate,
  setViewType,
}: CalendarHeaderProps) => {
  const currentYear = format(currentDate, 'yyyy');
  const currentMonth = format(currentDate, 'MMMM');

  return (
    <HeaderContainer>
      <FlexSpacer alignItems="center" gap={spacing.half}>
        <DateTitle>
          {currentMonth} <YearTitle>{currentYear}</YearTitle>
        </DateTitle>
        <CalendarNavigation
          currentDate={currentDate}
          setCurrentDate={setCurrentDate}
          viewType={viewType}
        />
      </FlexSpacer>
      <SegmentedControl
        data-test="calendar-view-toggle"
        onSelect={(value) => {
          setViewType(value);
        }}
        options={Object.values(CalendarViewType).map((viewType) => ({
          name: viewType,
          value: viewType,
        }))}
      />
    </HeaderContainer>
  );
};
